import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

if (window.bundleLocation) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.bundleLocation;
}

const injectReactLogin = (selector, parameters) => {
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }
  const reactRoot = createRoot(element);
  const App = lazy(
    () => import(/* webpackChunkName: "logon-component" */ './index'),
  );

  reactRoot.render(
    <Suspense>
      <App {...parameters} />
    </Suspense>,
  );
};

window.XM_injectReactLogin = injectReactLogin;
